import { render, staticRenderFns } from "./BalanceDetailsDialog.vue?vue&type=template&id=7cb5d372&scoped=true"
import script from "./BalanceDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./BalanceDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./BalanceDetailsDialog.vue?vue&type=style&index=0&id=7cb5d372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5d372",
  null
  
)

export default component.exports